import {AbstractPanel} from '../stats-panel';
import type {RenderingContext} from '../types';
import {patch} from '../utils';

export class DrawCallsPanel extends AbstractPanel {
    private static _realDrawElements: RenderingContext['drawElements'];

    private _gl!: RenderingContext;
    private _drawPasses = 0;

    public constructor(name = 'DC', bg = '#300', fg = '#f60', max = 50, decimals = 0) {
        super(name, bg, fg, max, decimals);
    }

    public get value(): number {
        return this._drawPasses;
    }

    public update(): void {
        this._drawPasses = 0;
    }

    public onInstall(gl?: RenderingContext): void {
        if (!gl) {
            throw Error('Stats: DrawCallsPanel > Rendering context must be provided');
        }

        this._gl = gl;

        DrawCallsPanel._realDrawElements = gl.drawElements;

        gl.drawElements = patch(gl.drawElements, this._fakeDrawElements.bind(this));
    }

    public onUninstall(): void {
        this._gl.drawElements = DrawCallsPanel._realDrawElements;
    }

    private _fakeDrawElements(): void {
        this._drawPasses++;
    }
}